"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giovanni-al-natisone": {
    "c24d1a28": [{
      "hkey": "94dee5c1",
      "slug": "san-giovanni-al-natisone",
      "name": "San Giovanni al Natisone",
      "primary": true,
      "skipSearch": false
    }],
    "bolzano": [{
      "hkey": "94dee5c1",
      "slug": "san-giovanni-al-natisone",
      "name": "San Giovanni al Natisone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c8b9e9a5": [{
      "hkey": "374523a3",
      "slug": "villanova",
      "name": "Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "villanova-del-judrio": [{
      "hkey": "374523a3",
      "slug": "villanova",
      "name": "Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;